import { V as VividElement, a as attr, n as nullableNumberConverter, h as html, d as createRegisterFunction, f as defineVividComponent } from './vivid-element.js';
import { i as iconDefinition } from './definition28.js';
import { A as AffixIconWithTrailing, a as affixIconTemplateFactory, I as IconWrapper } from './affix.js';
import { a as applyMixins } from './apply-mixins.js';
import { r as ref } from './ref.js';
import { w as when } from './when.js';

const styles = ":host{--_vvd-accordion-item-accent-firm-wrapper: var( --vvd-accordion-item-accent-firm )}.heading-button{--vvd-accordion-item-accent-firm: var( --_vvd-accordion-item-accent-firm-wrapper, var(--vvd-accordion-item-accent-primary) )}:host{display:flex;box-sizing:border-box;flex-direction:column}.heading-container{margin:0}.heading-button{--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: transparent;--_appearance-color-outline: transparent}.heading-button:where(.hover,:hover):where(:not(.disabled,:disabled,.readonly)){--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: var(--_connotation-color-faint);--_appearance-color-outline: transparent}.heading-button:where(.active,:active):where(:not(.disabled,:disabled)){--_appearance-color-text: var(--_connotation-color-firm);--_appearance-color-fill: var(--_connotation-color-soft);--_appearance-color-outline: transparent}.heading-button{--_connotation-color-faint: var(--vvd-accordion-item-accent-faint, var(--vvd-color-neutral-50));--_connotation-color-soft: var(--vvd-accordion-item-accent-soft, var(--vvd-color-neutral-100));--_connotation-color-firm: var(--vvd-accordion-item-accent-firm, var(--vvd-color-canvas-text))}.heading-button{--focus-stroke-gap-color: transparent;display:flex;width:100%;align-items:center;padding:16px;border:none;background-color:var(--_appearance-color-fill);color:var(--_appearance-color-text);cursor:pointer;text-align:left}.heading-button:focus-visible{box-shadow:inset 0 0 0 3px var(--focus-stroke-gap-color, currentColor);outline:2px solid var(--focus-stroke-color, var(--vvd-color-canvas-text));outline-offset:calc(-2px - var(--focus-inset, 0px))}.heading-button.size-condensed{font:var(--vvd-typography-base-extended-bold);gap:12px}.heading-button:not(.size-condensed){font:var(--vvd-typography-heading-4);gap:16px}.heading-content{flex:auto}.meta{overflow:hidden;max-width:var(--accordion-item-meta-inline-size, 20%);flex-shrink:0;color:var(--vvd-color-neutral-600);text-align:end;text-overflow:ellipsis;white-space:nowrap}.heading-button:not(.size-condensed) .meta{font:var(--vvd-typography-base-bold)}.heading-button.size-condensed .meta{font:var(--vvd-typography-base-condensed-bold)}.region{display:none;padding:8px 32px 24px 16px}.region:not(.size-condensed).padded{padding-inline-start:52px}:host([expanded]) .region{display:block}.region.size-condensed.padded{padding-inline-start:44px}slot[name=icon]{color:var(--vvd-color-neutral-600)}.heading-button:not(.size-condensed) slot[name=icon]{font:inherit}.heading-button.size-condensed slot[name=icon]{font:var(--vvd-typography-base-extended)}:host(:not([icon-trailing])) slot[name=icon]:last-of-type{color:var(--_appearance-color-text)}";

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class AccordionItem extends VividElement {
  constructor() {
    super(...arguments);
    this.headinglevel = 2;
    this.expanded = false;
    this.noIndicator = false;
    /**
     * @internal
     */
    this.clickHandler = () => {
      this.expanded = !this.expanded;
      this.change();
    };
    this.change = () => {
      this.$emit("change");
    };
  }
}
__decorateClass([
  attr({
    attribute: "heading-level",
    mode: "fromView",
    converter: nullableNumberConverter
  })
], AccordionItem.prototype, "headinglevel");
__decorateClass([
  attr({ mode: "boolean" })
], AccordionItem.prototype, "expanded");
// @ts-expect-error Type is incorrectly non-optional
__decorateClass([
  attr
], AccordionItem.prototype, "id");
__decorateClass([
  attr
], AccordionItem.prototype, "heading");
__decorateClass([
  attr({ mode: "boolean", attribute: "no-indicator" })
], AccordionItem.prototype, "noIndicator");
__decorateClass([
  attr
], AccordionItem.prototype, "meta");
__decorateClass([
  attr
], AccordionItem.prototype, "size");
applyMixins(AccordionItem, AffixIconWithTrailing);

const header = (context, hTag) => {
  const affixIconTemplate = affixIconTemplateFactory(context);
  return html`
		<${hTag} class="heading-container">
			<button
				class="heading-button ${(x) => x.size ? `size-${x.size}` : ""}"
				id="${(x) => x.id}"
				aria-expanded="${(x) => x.expanded}"
				aria-controls="${(x) => x.id}-panel"
				@click="${(x) => x.clickHandler()}"
				${ref("expandbutton")}
			>

				${(x) => !x.iconTrailing ? affixIconTemplate(x.icon, IconWrapper.Slot) : null}

				<span class="heading-content">${(x) => x.heading}</span>

				${when((x) => x.meta, html`<span class="meta">${(x) => x.meta}</span>`)}

				${(x) => x.icon && x.iconTrailing ? affixIconTemplate(x.icon) : null}
				${(x) => !(x.icon && x.iconTrailing) && !x.noIndicator ? affixIconTemplate(
    x.expanded ? "chevron-up-solid" : "chevron-down-solid"
  ) : null}

			</button>
		</${hTag}>
	`;
};
const AccordionItemTemplate = (context) => html`
	${(x) => header(context, "h" + x.headinglevel)}
	<div
		id="${(x) => x.id}-panel"
		aria-labelledby="${(x) => x.id}"
		role="region"
		class="region ${(x) => x.icon && !x.iconTrailing ? "padded" : ""} ${(x) => x.size ? `size-${x.size}` : ""}"
	>
		<slot></slot>
	</div>
`;

const accordionItemDefinition = defineVividComponent(
  "accordion-item",
  AccordionItem,
  AccordionItemTemplate,
  [iconDefinition],
  {
    styles
  }
);
const registerAccordionItem = createRegisterFunction(
  accordionItemDefinition
);

export { AccordionItem as A, accordionItemDefinition as a, registerAccordionItem as r };
